import React, { useRef, useState } from 'react';
import { TextField, IconButton, Paper } from '@mui/material';
import { Send } from '@mui/icons-material';

const MessageInput = ({ onSend, disabled }) => {
  const [text, setText] = useState('');
  const inputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim() || disabled) return;

    const toSend = text;
    await Promise.resolve(onSend(toSend));
    setText('');

    requestAnimationFrame(() => {
      inputRef.current?.focus?.();
    });
  };

  const handleKeyDown = (e) => {
    const isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    if (isMobile) {
      return;
    } else {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        handleSubmit(e);
      }
    }
  };

  return (
    <Paper
      component="form"
      onSubmit={handleSubmit}
      elevation={0}
      sx={{ 
        p: 1, 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1, 
        borderTop: '1px solid #eee',
        bgcolor: 'white'
      }}
    >
      <TextField
        size="small"
        fullWidth
        multiline
        maxRows={4}
        placeholder="메시지를 입력하세요"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        autoComplete="off"
        inputRef={inputRef}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            bgcolor: '#f5f5f5',
            '& fieldset': { border: 'none' },
            alignItems: 'flex-end',
          },
          '& .MuiInputBase-input': {
            paddingTop: '8px',
            paddingBottom: '8px',
          }
        }}
      />
      <IconButton
        type="submit"
        color="primary"
        disabled={disabled || !text.trim()}
        onMouseDown={(e) => e.preventDefault()}
        onTouchStart={(e) => e.preventDefault()}
      >
        <Send />
      </IconButton>
    </Paper>
  );
};

export default MessageInput;
